module.exports = __webpack_public_path__ + "img/climate_change_mitigation.6c84748.svg";